import { Component } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
import { TypesenseProvider } from '../../providers/typesense/typesense';

/**
 * Generated class for the CoPopoverSearchFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
let discoverFilterByTypes: Array<any>;

@Component({
  selector: 'co-popover-search-filter',
  templateUrl: 'co-popover-search-filter.html'
})
export class CoPopoverSearchFilterComponent {
  searchSource: string;
  filterShow: string;
  searchBy: string = '';
  sortBy: string = '';
  limitBy: string = '';
  filterByTypesLoading = false;
  filterByTypes: Array<any> = [];
  limitByTypes: Array<any> = [];
  searchTypes: Array<any> = [];
  sortByTypes: Array<any> = [];
  constructor(public viewCtrl: ViewController, public navParams: NavParams, public locationsProvider: LocationsProvider, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider, private typesense: TypesenseProvider, private state: AppState) {
    this.filterShow = this.navParams.data.data || 'searchBy';
    if(this.state.searchSource==='discover' && this.navParams.data.searchSource==='ils'){
      this.searchTypes = [{ 'v': 'full', 't': 'Any Field' },
      { 'v': 'ti', 't': 'Title' },
      { 'v': 'cr.n', 't': 'Author' },
      { 'v': 'ids.v', 't': 'ISBN' },
      { 'v': 'sb', 't': 'Subject' }];

      this.searchBy = this.navParams.data.current.searchBy;

      if(discoverFilterByTypes) {
        this.filterByTypes = discoverFilterByTypes;
      } else {
        typesense.init().then(() => {
          this.filterByTypesLoading = true;
          var searches = {
            searches: [
              { q: '*' }
            ]
          };
          var commonParams = {
            preset: typesense.preset,
            facet_by: 'f',
            per_page: 0,
            max_facet_values: 100,
          };
          typesense.client.multiSearch.perform(searches, commonParams)
          .then( res => {
            if(res.results && res.results.length > 1) {
              const facets = res.results[1].facet_counts[0].counts.map( count => {
                return count.value;
              });
              this.filterByTypes = facets.map( f => {
                return {t: f, selected: this.navParams.data.current.filterBy.indexOf(f) >= 0};
              });
              this.filterByTypes.sort( (a,b) => {
                return a.t.localeCompare(b.t, undefined, {numeric: true, sensitivity: 'base'})
              });
              discoverFilterByTypes = this.filterByTypes;
              this.filterByTypesLoading = false;
            }
          })
          .catch(() => {
            this.filterByTypesLoading = false;
          });
        });
      }
		} else {
      this.searchTypes = this.navParams.data.searchByList || this.state.searchByList;
      this.limitByTypes = this.navParams.data.limitByTypes || this.state.limitByList;
      this.sortByTypes = this.navParams.data.sortByList || this.state.sortByList;
      this.searchBy = this.navParams.data.current.searchBy;
      if (!this.navParams.data.current.sortBy) {
        this.sortBy = "RELEVANCE";
      } else {
        this.sortBy = this.navParams.data.current.sortBy;
      }
      this.limitBy = this.navParams.data.current.limitBy;
      console.log(this.navParams.data.current);
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  setSearchBy(reset?) {
    if (reset) {
      this.searchBy = 'full';
    } else {
      this.viewCtrl.dismiss({limitBy: this.limitBy, searchBy: this.searchBy, sortBy: this.sortBy}).catch(err=>{});
    }
  }
  setFilterBy(reset?) {
    if (reset) {
		this.filterByTypes.forEach(f=>f.selected=false)
    } else {
      this.viewCtrl.dismiss({filterBy: this.filterByTypes.filter(f=>f.selected).map(f=>f.t)}).catch(err=>{});
    }
  }
  setLimitBy(reset?) {
    if (reset) {
      this.limitBy = null;
    } else {
      this.viewCtrl.dismiss({limitBy: this.limitBy, searchBy: this.searchBy, sortBy: this.sortBy}).catch(err=>{});
    }
  }
  setSortBy(reset?) {
    if (reset) {
      this.sortBy = 'RELEVANCE';
    } else {
      this.viewCtrl.dismiss({limitBy: this.limitBy, searchBy: this.searchBy, sortBy: this.sortBy}).catch(err=>{});
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-popover-search-filter/co-popover-search-filter.ts